import { CounsellingPath } from './types';

/**
 * Resolves the counselling page title from the `path` query param.
 * Shared between the DEE component's in-page heading and the app-shell
 * Breadcrumb, so both stay in sync.
 */
export const resolveCounsellingTitle = (
  path: CounsellingPath | string
): string => {
  switch (path) {
    case 'candidate':
      return 'Check Candidate List';
    case 'vacancy':
      return 'Check Vacancy';
    case 'order-copy':
      return 'Update Order Copy Details';
    case 'update-vac':
      return 'Update Vacancies';
    case 'seniority':
      return 'Update Seniority';
    case 'add-candidate':
      return 'Add Candidate List';
    case 'counseling-reset':
      return 'Counselling Reset';
    default:
      return 'Conduct Counselling';
  }
};
